import React, { useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import { SEOHelmet } from '../../hooks/useSEO';

import { FaAngleDoubleRight } from "react-icons/fa";
import rabbit from "../../assets/blogpages/2x/Asset 84@2x.png";
import buffalo from "../../assets/blogpages/2x/blog 8 set 24 img2.png";
import Koala_Sheep from "../../assets/blogpages/2x/Set 47 Blog 15 Img2.png";
import Eliphiphi from "../../assets/blogpages/2x/Blog 17 Set 23 Img2.png";
import turtle from "../../assets/blogpages/2x/blog 8 set 24 img1.png";
import Liona_Sheepu from "../../assets/blogpages/2x/Set 47 Blog 15 Img1.png";
import Tigru from "../../assets/blogpages/2x/Blog 17 Set 23 Img1.png";
import activity1 from "../../assets/blogpages/2x/Blog 17 Set 23 AC1.jpg";
import activity2 from "../../assets/blogpages/2x/Blog 17 Set 23 AC2.jpg";
import finalElephant from "../../assets/blogpages/2x/Asset 71@2x.png";
import safiaElephant from "../../assets/blogpages/2x/Asset 73@2x.png";
import { Link, useParams, useNavigate } from "react-router-dom";

import TheChallenge from "../../assets/blogpages/2x/Asset 97@2x.png";
import Whattodo from "../../assets/blogpages/2x/Asset 95@2x.png";
import Whatnottodo from "../../assets/blogpages/2x/Asset 93@2x.png";
import activitycard from "../../assets/blogpages/2x/Asset 94@2x.png";
import whatchlearn from "../../assets/blogpages/2x/Asset 96@2x.png";
import board from "../../assets/blogpages/2x/Asset 90@2x.png";


import weeklyActivity2 from "../../assets/blogpages/2x/Asset 39@2x.png";
import Linkdin from "../../assets/blogpages/2x/Asset 70@2x.png";
import youtube from "../../assets/blogpages/2x/Asset 80@2x.png";
import facebook from "../../assets/blogpages/2x/Asset 81@2x.png";
import instaIcon from "../../assets/blogpages/2x/Asset 69@2x.png";
import Pinterest from "../../assets/blogpages/2x/Asset 83@2x.png";
import share from "../../assets/blogpages/2x/Asset 78@2x.png";
import thumbnail from "../../assets/blogs/2x/Blog 17 Set 23 Thumbnail.png";
import bell from "../../assets/blogpages/2x/Asset 75@2x.png";
import weeklyActivity from "../../assets/blogpages/2x/Asset 74@2x.png";
// import kidsStory from "../../assets/blogpages/Story/Set 47 Blog 15 KidzSong.png";
import KidsStory from "../../assets/blogpages/Jingle/Blog 17 Set 23 KidsStory.png";
// import kidsSong from "../../assets/blogpages/Jingle/set 01.png";
import kidsSong from "../../assets/blogpages/Jingle/Blog 17 Set 23 KidsSong.png";
import kidslearning from "../../assets/blogpages/Interactive/Blog 17 Set 23 KidsLearning.png";



import boardimg from "../../assets/blogs/2x/Asset 25@2x.png";
import elephantImg from "../../assets/blogs/2x/Asset 22@2x.png";
import cowImg from "../../assets/blogs/2x/Asset 31@2x.png";
import lionImg from "../../assets/blogs/2x/Asset 29@2x.png";
import deerImg from "../../assets/blogs/2x/Asset 30@2x.png";
import turtleImg from "../../assets/blogs/2x/Asset 28@2x.png";
import elephiImg from "../../assets/blogs/2x/Asset 32@2x.png";
import geassdivImg from "../../assets/blogs/2x/Asset 23@2x.png";
import blog1Img from "../../assets/blogs/2x/Asset 24@2x.png";
import styles from "./JungleMoralsUI.module.css"
import thumbnail1 from "../../assets/blogs/2x/Blog 16 Set 31 thumbanil.png";
import thumbnail2 from "../../assets/blogs/2x/set  37 blog 11 thumbnail.png";
import thumbnail3 from "../../assets/blogs/2x/Blog 9 Set 22.png";
import { Helmet } from "react-helmet-async";




const Helpingkidslearntocontrolangerandmanagebigfeelings = () => {

    const params = useParams();
    const slug = params.slug || "helping-kids-learn-to-control-anger-and-manage-big-feelings";
    const navigate = useNavigate();

    // ✅ Blog data ko slug se match karo (optional - agar dynamic content chahiye)
    const blogData = {
        "helping-kids-learn-to-control-anger-and-manage-big-feelings": {
            title: "Helping Kids Learn to Control Anger and Manage Big Feelnigs",
            date: "07 January 2026",
            readTime: "4 min read"
        },
    };

    const currentBlog = blogData[slug] || {
        title: "Blog Not Found",
        date: "",
        readTime: ""
    };
 
     const handleBlogClick = (slug) => {
    navigate(`/blog/${slug}`);
  };



    const blogPost = [
        {
            id: 1,
            title: "Kids Story",
            animal: "elephant",
            animalImg: elephantImg,
            image: KidsStory,
            youtubeLink: "https://www.youtube.com/watch?v=MQ7Uc0b73Uo" // Apna link yahan daalo
        },
        {
            id: 2,
            title: "Kids Song",
            animal: "cow",
            animalImg: cowImg,
            image: kidsSong,
            youtubeLink: "https://www.youtube.com/watch?v=YakbEAW_QE8"
        },
        {
            id: 3,
            title: "Kids Learning",
            animal: "lion",
            animalImg: lionImg,
            image: kidslearning,
            youtubeLink: "https://www.youtube.com/watch?v=hu6yreqATc4"
        },
    ];


    const blogPosts = [

        {
            id: 1,
            title: "Helping Kids Believe in Themselves...",
            description: "Simple conversations, everyday situations, and a kids moral story that help children recognise greed, value friendsh...",
            date: "5 April 2026",
            readTime: "4 min read",
            animal: "deer", // brown deer
            animalImg: deerImg, // Yahan image add karein
            image: thumbnail1,
               slug: "helping-kids-believe-in-themselves-and-trust-that-things-workout",
               alt:"Cartoon lion with a bow and arrow promoting trust the journey, staying safe, and self-love.",
        },
        {
            id: 2,
            title: "Helping Kids Choose What Is Right...",
            description: "Simple conversations, everyday habits, and a kids moral story that help children understand right and wrong...",
            date: "28 February 2026",
            readTime: "6 min read",
            animal: "turtle", // green turtle
            animalImg: turtleImg, // Yahan image add karein
            image: thumbnail2,
               slug: "helping-kids-choose-what-is-right-instead-of-what-is-easy",
               alt:"Cartoon lion teaching right vs wrong and critical thinking for kids."
        },
        {
            id: 3,
            title: "Helping Kids Build Self Love and Inner...",
             description: "Simple reflections, everyday conversations, and a kids moral story that help children understand their inner world...",
            date: "14 February 2026",
            readTime: "6 min read",
            animal: "elephant2", // gray elephant
            animalImg: elephiImg, // Yahan image add karein
            image: thumbnail3,
               slug: "helping-kids-build-self-love-and-inner-strength",
               alt:"Sheep thumbnail about kindness, self-love, and gratitude.",
        }
    ];

    const animalStyles = {
        elephant: { top: '-50px', left: '-80px', transform: 'scale(0.8)' },
        cow: { top: '-75px', left: '50%', transform: 'translateX(-50%) scale(0.7)' },
        lion: { top: '-80px', right: '-60px', transform: 'scale(0.8)' },
        deer: { top: '-85px', left: '-85px', transform: 'scale(0.75)' },
        turtle: { top: '-80px', left: '50%', transform: 'translateX(-50%) scale(0.7)' },
        elephant2: { top: '-70px', right: '-80px', transform: 'scale(0.8)' }
    };

    //share blogs function
    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: document.title,
                    // text: 'Is blog ko dekho ',
                    url: window.location.href,
                });
            } catch (err) {
                // user ne cancel kiya to kuch mat karo
            }
        } else {
            alert('Share supported nahi hai is browser me');
        }
    };



    const socialLinks = [
        { img: Linkdin, link: "https://www.linkedin.com/company/jungle-morals-entertainment/?viewAsMember=true" },
        { img: youtube, link: "https://www.youtube.com/channel/UCF4P0048BiT04m1ss61qpGA" },
        { img: facebook, link: "https://www.facebook.com/junglemorals/" },
        { img: instaIcon, link: "https://www.instagram.com/junglemorals/" },
        { img: Pinterest, link: "https://in.pinterest.com/junglemorals/" },
        { img: share, isShare: true },
    ];

    const TopCard = ({ title, img, onClick }) => (
        <div className="col-4 col-sm-4 col-md-4 col-lg">
            <div
                onClick={onClick}
                className="position-relative overflow-hidden"
                style={{ cursor: "pointer" }}
            >
                {/* Background image */}
                <img src={img} alt={title} className="img-fluid w-100" />

                {/* Overlay text */}
                <div
                    className={`position-absolute top-50 start-50 translate-middle fw-bold ${styles.usereff}`}

                >
                    {title}
                </div>
            </div>
        </div>
    );


    const challengeRef = useRef(null);
    const whatToDoRef = useRef(null);
    const whatNotRef = useRef(null);
    const activityRef = useRef(null);
    const watchRef = useRef(null);
    const newsletterRef = useRef(null);


    const scrollTo = (ref) => {
        ref.current.scrollIntoView({ behavior: "smooth" });
    };

    //for the margintop fix of page
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 585);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 585);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);



    //SEO meta information


    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    // useEffect(() => {
    //     // Fetch blogs from localStorage (same as admin dashboard)
    //     const blogs = JSON.parse(localStorage.getItem("adminBlogs"));

    //     if (blogs) {
    //         const currentBlog = blogs.find(b => b.slug === slug);
    //         setBlog(currentBlog);
    //     }

    //     setLoading(false);
    // }, [slug]);

    // if (loading) {
    //     return <div className="container py-5 text-center">Loading...</div>;
    // }

    // if (!blog) {
    //     return (
    //         <div className="container py-5">
    //             <div className="alert alert-danger">
    //                 <h4>Blog not found</h4>
    //                 <p>Sorry, the blog post you're looking for doesn't exist.</p>
    //             </div>
    //         </div>
    //     );
    // }


    return (

        <>
            <Helmet>
    <title>Teaching Kids to Manage Anger Calmly with Jungle Morals</title>

    <meta
        name="description"
        content="Help kids aged 3-7 recognise and manage anger without shame or suppression. Gentle parenting tips to teach emotional regulation, calming techniques, and loving responses."
    />

    <link
        rel="canonical"
        href="https://www.junglemorals.com/blog/helping-kids-learn-to-control-anger-and-manage-big-feelings"
    />
     
     <meta property="og:title" content="Teaching Kids to Manage Anger Calmly with Jungle Morals" />
<meta property="og:description" content="Help kids aged 3-7 recognise and manage anger without shame or suppression." />
<meta property="og:type" content="article" />
<meta property="og:url" content="https://www.junglemorals.com/blog/helping-kids-learn-to-control-anger-and-manage-big-feelings" />
<meta property="og:image" content="https://www.junglemorals.com/static/media/Blog%2017%20Set%2023%20Thumbnail.403a1773646767512669.png" />

<meta name="twitter:card" content="summary_large_image" />
<meta name="twitter:title" content="Teaching Kids to Manage Anger Calmly with Jungle Morals" />
<meta name="twitter:description" content="Help kids aged 3-7 recognise and manage anger without shame or suppression." />
<meta name="twitter:image" content="https://www.junglemorals.com/static/media/Blog%2017%20Set%2023%20Thumbnail.403a1773646767512669.png" />

<meta name="robots" content="index, follow" />

    <script type="application/ld+json">
        {JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
                {
                    "@type": "BreadcrumbList",
                    "@id": "https://www.junglemorals.com/blog/helping-kids-learn-to-control-anger-and-manage-big-feelings#breadcrumb",
                    "itemListElement": [
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "Home",
                            "item": "https://www.junglemorals.com/"
                        },
                        {
                            "@type": "ListItem",
                            "position": 2,
                            "name": "Blogs",
                            "item": "https://www.junglemorals.com/blog"
                        },
                        {
                            "@type": "ListItem",
                            "position": 3,
                            "name": "Helping Kids Learn to Control Anger and Manage Big Feelings",
                            "item": "https://www.junglemorals.com/blog/helping-kids-learn-to-control-anger-and-manage-big-feelings"
                        }
                    ]
                },
                {
                    "@type": "BlogPosting",
                    "@id": "https://www.junglemorals.com/blog/helping-kids-learn-to-control-anger-and-manage-big-feelings#blogposting",
                    "mainEntityOfPage": {
                        "@type": "WebPage",
                        "@id": "https://www.junglemorals.com/blog/helping-kids-learn-to-control-anger-and-manage-big-feelings"
                    },
                    "headline": "Helping Kids Learn to Control Anger and Manage Big Feelings",
                    "description": "Children between ages 3–7 experience emotions deeply, and anger can often feel overwhelming. As they grow, they are still learning how to recognise feelings, calm their bodies, and express emotions in healthy ways. With gentle guidance, patience, and emotional support, children can develop important self-regulation skills that help them respond with kindness instead of frustration. This guide explores simple and effective anger management techniques for kids, helping parents teach emotional control, calm communication, and healthy coping habits in everyday situations.",
                    "image": [
                        "https://www.junglemorals.com/static/media/Blog%2017%20Set%2023%20Thumbnail.403a1773646767512669.png",
                        "https://www.junglemorals.com/static/media/Blog%2017%20Set%2023%20Img1.062b22cc48f5d7e7e9f6.png",
                        "https://www.junglemorals.com/static/media/Blog%2017%20Set%2023%20Img2.9aa50c4f33439c5db240.png"
                    ],
                    "author": {
                        "@type": "Organization",
                        "name": "Jungle Morals"
                    },
                    "publisher": {
                        "@type": "Organization",
                        "name": "Jungle Morals",
                        "logo": {
                            "@type": "ImageObject",
                            "url": "https://www.junglemorals.com/static/media/Asset.4660813ebac538e8b202.webp"
                        }
                    },
                    "datePublished": "2026-03-13",
                    "dateModified": "2026-03-13",
                    "breadcrumb": {
                        "@id": "https://www.junglemorals.com/blog/helping-kids-learn-to-control-anger-and-manage-big-feelings#breadcrumb"
                    }
                }
            ]
        })}
    </script>
</Helmet>

            <div className="" style={{
                color: '#005d52',
                marginTop: isMobile ? '-62vh' : '-45vh',
                minHeight: '100vh',
                position: 'relative',
                overflow: 'hidden',

            }}>
                <div className="container py-3 py-md-2 col-md-10 text-start" style={{ maxWidth: '1300px' }}
                >

                    {/* Breadcrumb Path */}
                  <div className={`path fs-4 ${styles.Breadcrumb} p-2 m-0 ps-0 mb-3 mb-md-2 d-flex flex-wrap align-items-center gap-2 font-brandon z-2`}>
                        <Link to={'/'} className="text-decoration-none text-reset pe-auto z-1">
                            <span className="path-element text-pr-black ff-roboto pe-auto">Home</span>
                        </Link>
                        <FaAngleDoubleRight className="fa-icons" style={{ fontSize: '12px' }} />
                        <Link to={'/blogs'} className="text-decoration-none text-reset z-1">
                            <span className="path-element text-pr-black ff-roboto">Blogs</span>
                        </Link>
                        <FaAngleDoubleRight className="fa-icons" style={{ fontSize: '12px' }} />
                        <span className="path-element">Helping Kids Learn to Control Anger and Manage Big Feelings</span>
                    </div>
                    {/* Main Heading */}
                    <h1 className={`font-brandon-black  display-1 fw-bold ${styles.mainh1} `} >
                       Helping Kids Learn to Control Anger and Manage Big Feelings
                    </h1>

                    {/* Subheading */}
                    <p className={`font-brandon-thin-italic ${styles.tagline} lh-sm fst-italic`}>
                        Simple conversations, calming strategies, and a kids moral story that help children understand anger, regulate emotions, and respond with love.
                    </p>

                    {/* Social Links & Date Section */}
                    <div className="path m-0 ps-0  mb-md-2 d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-3 gap-sm-2">

                        {/* Social Icons */}
                        <div className="path-element text-muted ff-roboto d-flex align-items-center gap-3 order-2 order-sm-1">
                            {socialLinks.map((item, index) => (
                                <a
                                    key={index}
                                    href={item.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="d-inline-block"
                                >
                                    <img
                                        src={item.img}
                                        alt="social-icon"
                                        width="40"
                                        height="40"
                                        className="social-icon"
                                        style={{ objectFit: "contain", cursor: "pointer" }}
                                        onClick={() => {
                                            if (item.isShare) {
                                                handleShare();        // ✅ native share
                                            } else {
                                                window.open(item.link, '_blank'); // ✅ normal social links
                                            }
                                        }}

                                    />
                                </a>
                            ))}
                        </div>

                        {/* Date & Read Time */}
                        <div className="d-flex flex-row flex-sm-column align-items-start align-items-sm-end gap-2 gap-sm-1 order-1 order-sm-2 font-brandon">
                              <small className={`text-nowrap ${styles.date}`} style={{ color: '#005d52', fontSize: '20px', fontWeight: "900" }}>
                                13 March 2026
                            </small>
                            <span className="d-inline d-sm-none text-muted">•</span>
                             <small className={`text-nowrap ${styles.date}`} style={{ color: '#005d52', fontSize: '20px', fontWeight: "900" }}>
                                5 min read
                            </small>
                        </div>
                    </div>
                </div>



                <div className="container-fluid mb-2 px-3 px-md-4" style={{ maxWidth: '1600px' }}
                >
                    <div className="row justify-content-center">
                        <div className="col-12 col-xl-10">
                            <div className={`row text-center g-2 g-md-3 font-brandon-bold  ${styles.strongtext}`}>
                                <TopCard title="The Challenge" img={TheChallenge} onClick={() => scrollTo(challengeRef)} />
                                <TopCard title="What To Do" img={Whattodo} onClick={() => scrollTo(whatToDoRef)} />
                                <TopCard title="What NOT To Do" img={Whatnottodo} onClick={() => scrollTo(whatNotRef)} />
                                <TopCard title="Activity Card" img={activitycard} onClick={() => scrollTo(activityRef)} />
                                <TopCard title="Watch and Learn" img={whatchlearn} onClick={() => scrollTo(watchRef)} />
                            </div>
                        </div>
                    </div>
                </div>


                <section ref={challengeRef} className="container  col-md-10" style={{ maxWidth: '1300px' }}
                >
                    <div className="d-flex justify-content-center align-items-center flex-column">


                        <div
                            className="text-center board-wrapper"
                            style={{
                                backgroundImage: `url(${boardimg})`,
                                backgroundSize: 'contain',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                aspectRatio: '16 / 10',     // ⭐ key fix
                            }}
                        >
                            <img
                                src={thumbnail}
                                alt="Cartoon elephant about controlling anger and inner strength."
                                style={{
                                    width: '93%',
                                    height: '90%',
                                    objectFit: 'contain',
                                }}
                            />
                        </div>

                        <div className="">
                            <h2 className={`font-brandon-black   ${styles.strongtextheading} `}>Introduction</h2>
                            <p className={`font-brandon ${styles.introtext} lh-sm mb-5`}>Between ages<strong className={styles.strongtext}> 3-7</strong>children experience emotions intensely. Anger can rise quickly when they feel tired, misunderstood, or overwhelmed. At this age, children are still learning how to <strong className={styles.strongtext}> recognise emotions</strong>and express them safely.</p>

                            <p className={`font-brandon ${styles.introtext} lh-sm mb-5`}>Parents often look for ways to <strong className={styles.strongtext}>help children control anger</strong> without suppressing feelings. Teaching emotional regulation helps children understand that anger is normal, but how we respond to it matters.</p>


                            <p className={`font-brandon ${styles.introtext} lh-sm`}>This week at Jungle Morals, we explore how children can learn to manage anger, calm their bodies and minds, and choose loving responses even during difficult moments.
</p>
                        </div>

                    </div>
                </section>


                <section ref={challengeRef} className="container py-3 col-md-10 mt-4" style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon-black   ${styles.strongtextheading}`} >The Challenge</h2>
                    <p className={`font-brandon ${styles.fs2} ${styles.TheChallengeh2} lh-sm mb-4 mb-md-5 fst-italic`}>Why children struggle with anger control</p>
                    <p className={`font-brandon ${styles.fs2} ${styles.mobilefs2} lh-sm mb-4 mb-md-5`}>Young children do not yet have fully developed emotional regulation skills. When something feels unfair or frustrating, anger can take over quickly.</p>
                    <div className="row align-items-center justify-content-center">
                        <div className="col-md-6">


                            <h3 className={`font-brandon-black  ${styles.strongtext2} `}>Parents may notice children:</h3>
                            <ul className={`font-brandon ${styles.ul21} lh-sm  ps-4.5 mb-md-5`}>
                                <li>Shouting or crying suddenly</li>
                                <li>Hitting or throwing things</li>
                                <li>Refusing to listen</li>
                                <li>Feeling guilty after an outburst</li>
                                <li>Struggling to calm down</li>
                            </ul>

                            <h3 className={`font-brandon-black  ${styles.strongtext2} `}>You may hear children say:</h3>
                            <ul className={`font-brandon ${styles.ul21} lh-sm  ps-4.5 mb-5`} >
                             <li>“It is not fair.”</li>
                                <li>“I am so angry.”</li>
                                <li>“I cannot stop.”</li>
                                <li>“They made me mad.”</li>
                                {/* <li>“Can you do it for me?”</li> */}
                            </ul>
                        </div>

                        <div className="col-md-6 text-center">
                            <img src={Tigru} className={`${styles.Liona} img-fluid`} alt="Angry cartoon tiger cub clenching fists, showing frustration and strong emotions." width={"260"} />
                        </div>
                        <p className={`font-brandon ${styles.introtext}  lh-sm mb-5`}>These reactions are common. Children between ages 3–7 are still learning how to identify emotions and manage strong feelings safely.</p>

                          {/* <p className={`font-brandon ${styles.introtext}  lh-sm mb-5`}>Small image on the right: a Jungle Morals character thinking before choosing between two options.</p> */}


                    </div>
                </section>



                <section ref={whatToDoRef} className="container mb-5 col-md-10 py-1" style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon-black mt-2 mb-3 ${styles.strongtextheading}`}>What To Do: Helping Kids Choose Kind Words and Support Friends</h2>
                    <p className="font-brandon fs-3 lh-sm fst-italic">Here are gentle ways to support emotional regulation:</p>
                    <div className="row align-items-center justify-content-center">
                        <div className={`col-md-6 ${styles.WTD}`}>

                            <h3 className={`font-brandon-bold mt-3 ${styles.li_text}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Name the feeling</h3>
                            <ul className={`font-brandon mt-2 ${styles.li_t} ${styles.li_WTDp2} lh-sm  ps-0`}>
                                <li>Help children recognise emotions.</li>
                                <li>“I see you are feeling angry.”</li>
                            </ul>

                            <h3 className={`font-brandon-bold mt-5 ${styles.li_text}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Teach calming techniques</h3>
                            <ul className={`font-brandon mt-2 ${styles.li_t} ${styles.li_WTDp2} lh-sm  ps-0`}>
                                <li>Show simple ways to calm the body.</li>
                                <li>“Let us take three slow breaths together.”</li>
                            </ul>

                            <h3 className={`font-brandon-bold mt-5 ${styles.li_text}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Create a safe pause</h3>
                            <ul className={`font-brandon mt-2 ${styles.li_t} ${styles.li_WTDp2} lh-sm  ps-0`}>
                                <li>Encourage stepping away to calm down.</li>
                                <li>“We can talk after we feel calmer.”</li>
                            </ul>

                            <h3 className={`font-brandon-bold mt-5 ${styles.li_text}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Talk about feelings after</h3>
                            <ul className={`font-brandon mt-2 ${styles.li_t} ${styles.li_WTDp2} lh-sm  ps-0`}>
                                <li style={{width:"45rem"}}>Once calm, reflect together.</li>
                                <li>“What made you feel this way?”</li>
                            </ul>

                            <h3 className={`font-brandon-bold mt-5 ${styles.li_text}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                               Model calm behaviour</h3>
                            <ul className={`font-brandon mt-2 ${styles.li_t} ${styles.li_WTDp2} lh-sm  ps-0`}>
                                <li>Children learn emotional control by watching adults.</li>
                            </ul>

                        </div>
                        <div className="col-md-6 text-center">
                            <img src={Eliphiphi} className="img-fluid" alt="Cartoon elephant making a heart shape with hands, expressing love and kindness." width={"550"} />
                        </div>
                    </div>
                </section>


                <section ref={whatNotRef} className="container col-md-10 py-1 mt-3" style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon-black mb-2 ${styles.strongtextheading}`}>What NOT To Do</h2>
                    <p  className={`font-brandon ${styles.fs2} ${styles.TheChallengeh2} lh-sm mb-4 fst-italic`}>When teaching anger management, avoid these habits.</p>
                    <div className=" col-md-12">
                        <h5 className={`font-brandon-bold ${styles.fs2} ${styles.strongtext} `}>Avoid:</h5>
                        <ul className="font-brandon fs-3 lh-sm  list-unstyled ps-0">
                            <li>
                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                Do not shame anger</li>
                            <li>
                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                Do not demand instant calm</li>
                            <li>
                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                Do not ignore big feelings</li>
                            <li>
                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                	Do not label children as bad</li>
                            <li>

                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                	Do not punish emotional expression</li>

                        </ul>

                        
                        <p className={`font-brandon ${styles.fs2} ${styles.mobilefs2}  lh-sm mt-4 mt-md-5`}>Emotional control grows through understanding and practice.</p>
                        <p className={`font-brandon ${styles.fs2} ${styles.belltext} lh-sm mt-4 mt-md-5`}>
                                                                                     <img
                                                                          src={bell}
                                                                          alt="Yellow notification bell icon flat design"
                                                                          width="50px"
                                                                          className="mb-2 me-3"
                                                                        />
                                                                                      Want weekly Jungle activities, updates, and more?{" "}
                                                                                      <Link
                                                                                        to="#"
                                                                                        onClick={(e) => {
                                                                                          e.preventDefault();
                                                                        
                                                                                          if (newsletterRef.current) {
                                                                                            newsletterRef.current.scrollIntoView({
                                                                                              behavior: "smooth",
                                                                                              block: "center",
                                                                                            });
                                                                                          }
                                                                                        }}
                                                                                      >
                                                                                        {" "}
                                                                                        Join Our Newsletter!
                                                                                      </Link>
                                                                                    </p>
                    </div>
                </section>


                <section ref={activityRef} className="container py-1 col-md-10 " style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon-black mt-4  ${styles.strongtextheading}`}>‘What To Do’ Activity Card:</h2>
                    <p className={`font-brandon ${styles.fs2} ${styles.mobilefs2} lh-sm fst-italic`}>A Fun Way to Help Kids Calm Down and Manage Emotions</p>

                    <div className="row my-4">
                        <div className="col-md-6">
                            <img src={activity1} alt="Kids anger control activity card with elephant and lion, titled “What To Do?”" className="img-fluid " />
                        </div>
                        <div className="col-md-6">
                            <img src={activity2} alt="Kids calming activity using a choice wheel with breathing, drawing, talking, counting, and outdoor play." className="img-fluid " />
                        </div>
                    </div>
                    <p className={`font-brandon ${styles.fs2} ${styles.mobilefs2} lh-sm fst-italic`} >Why this activity works:
                       This activity helps children practice calming techniques and recognise emotions before reacting. It builds awareness and emotional balance.</p>

                </section>

                <section ref={watchRef} className="container col-md-10 py-1 mt-3" style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon-bold ${styles.strongtext}`}>How parents should guide it</h2>
                    <ul className={`font-brandon ${styles.fs2} lh-sm ${styles.activityULLI}  ps-0.5`}>
                        <li>Do the activity together during calm moments</li>
                        <li>Practice breathing or naming feelings</li>
                        <li>Encourage reflection without judgment</li>
                    </ul>


                    <h2 className={`font-brandon-bold ${styles.strongtext}`}>What children learn:</h2>
                    <ul className={`font-brandon ${styles.fs2} lh-sm ${styles.activityULLI}  ps-0.5`}>
                        <li>Emotional regulation</li>
                        <li>Recognising anger</li>
                        <li>Self calming skills</li>
                        <li>Responding with love</li>
                    </ul>


                    <div>

                        <div className="position-relative d-flex justify-content-center align-items-center my-4">
                                                                                      <Link
                                                                                        to={"/form"}
                                                                                        className="position-relative d-flex justify-content-center align-items-center my-4 text-reset"
                                                                                      >
                                                                                        <h3 className={`position-absolute ${styles.fs22} grab-text text-center font-adventuring`}>
                                                                                          Grab your free activity card
                                                                                        </h3>
                                                                        
                                                                                        {/* Board image */}
                                                                                        <img
                                                                                          src={board}
                                                                                          alt="Colorful festive marquee light frame with glowing multicolor bulbs and blank banner space"
                                                                                          className="img-fluid board-img"
                                                                                          width={"800px"}
                                                                                        />
                                                                                      </Link>
                                                                                    </div>


                        <h2 className={`font-brandon-bold   ${styles.strongtextheading}`}>Watch This Week’s - Goodie Cutie:</h2>
                        {/* Header Section */}
                        {/* Blog Cards Grid */}
                         <div className={`row ${styles.Links} g-2 g-md-5`}>
                            {blogPost.map((post, index) => (
                                <div key={post.id} className="col-12 col-md-6 col-lg-4">
                                    <div
                                        className="card h-100"
                                        style={{
                                            border: 'none',
                                            cursor: 'pointer',
                                            transition: 'transform 0.3s ease'
                                        }}
                                        onClick={() => window.open(post.youtubeLink, '_blank')}
                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                    >
                                        {/* Card Image/Content Area */}
                                        <div style={{
                                            height: '240px',
                                            backgroundImage: `url(${boardimg})`,
                                            backgroundSize: 'contain',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            position: 'relative',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '10px 10px'
                                        }}>
                                            <img
                                                src={post.image}
                                                alt={post.title}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </div>

                                        {/* Grass decoration */}
                                        <div style={{
                                            width: "50%",
                                            minHeight: "150px",
                                            height: "30vw",
                                            maxHeight: "100px",
                                            marginTop: "24%",
                                            position: 'absolute',
                                            marginLeft: "61%",
                                        }}>
                                            <img
                                                src={geassdivImg}
                                                alt="grass decoration"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: "contain"
                                                }}
                                            />
                                        </div>

                                        <div className="card-body" style={{ padding: '1px' }}>
                                            <h5 className="card-title font-brandon-bold fs-3 lh-sm" style={{
                                                color: '#005d52',
                                                fontWeight: 'bold',
                                                fontSize: '22px',
                                                marginBottom: '10px',
                                                textAlign: "center"
                                            }}>
                                                {post.title}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>


                    </div>

                    <p className={`font-brandon ${styles.fs2} ${styles.mobilefs2} lh-sm mb-1 mt-4 mt-md-5`}>This animated kids moral story teaches:</p>
                    <ul  className={`font-brandon ${styles.fs2} ${styles.activityULLI} lh-sm   ps-0.5`}  >
                        <li>Understanding anger</li>
                        <li>Calming down safely</li>
                        <li>Emotional management</li>
                        <li>Choosing love over reactions</li>
                    </ul>
                    <p className={`font-brandon ${styles.fs2} ${styles.activityULLI} lh-sm mb-4 mt-0 mb-md-5 mt-md-5`}>Kids love watching characters make small choices that lead to big learnings.</p>
                    <p className={`font-brandon ${styles.fs30} lh-sm d-flex gap-3`}>
                                                     <img
                                                       src={bell}
                                                       alt="Yellow notification bell icon flat design"
                                                       srcset=""
                                                       width={"50px"}
                                                       className="mb-2  "
                                                     />
                                                     <Link
                                                       to={"https://www.youtube.com/channel/UCF4P0048BiT04m1ss61qpGA"}
                                                       target="blank"
                                                     >
                                                       Watch more Jungle Morals stories on YouTube!
                                                     </Link>
                                                   </p>

                    <h4 className={`font-brandon-bold  mt-5 ${styles.strongtextheading}`}>Final Thoughts & Learnings</h4>
                    <ul className={`font-brandon ${styles.fs2} ${styles.activityULLI} lh-base   ps-0.5`}>
                        <li>Children learn punctuality through habits, not pressure</li>
                        <li>Time awareness develops slowly between ages three to seven</li>
                        <li>Visual routines help children understand daily time flow</li>
                        <li>Gentle reminders work better than rushing or scolding</li>
                        <li>Preparation reduces morning stress and last-minute delays</li>
                        <li>Praising e ort builds responsibility and self-confidence</li>
                        <li>Play-based activities make time management easier to learn</li>
                        <li>Consistency turns small routines into lifelong punctual habits</li>
                    </ul>

                </section>


                <section className={styles.wisdomSection} style={{ maxWidth: '2900px' }}
                >
                    <div className="container-fluid px-0" style={{ maxWidth: '1600px' }} >
                        <div className="row align-items-center justify-content-start mx-0">
                            <div className={`col-auto text-center ${styles.elephantCol}`}>
                                <img
                                    src={finalElephant}
                                    className={`img-fluid ${styles.elephantImage}`}
                                    alt="elephant"
                                        style={{ marginTop: '-200px' }}   
                                />
                            </div>
                            <div className="col text-start text-white ps-0 ps-sm-3 ps-md-4 ps-lg-2 mb-md-5 ">
                                <h4 className={`font-brandon  mb-1 ${styles.wisdomTitle}`}>Final Jungle Wisdom</h4>
                                <p className={`font-brandon  lh-sm mb-1 ${styles.wisdomText}`}>
                                   When children learn to understand their anger, they learn to respond with love.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>




               
                              <section
                                        className="container py-5 col-md-10 text-start d-flex justify-content-evenly flex-column"
                                        style={{ maxWidth: "1300px" }}
                                      >
                                        <h3 className={`font-brandon-black mt-3 mb-3 ${styles.strongtextheading}`}>
                                          Get Weekly Jungle Activities, Updates and More!
                                        </h3>
                                        <p className={`font-brandon ${styles.fs3} fst-italic lh-sm`}>
                                          One simple activty and one gentle parenting tip every week.
                                        </p>
                              
                                         <div
                                                    className="d-flex justify-content-center px-2"
                                                    ref={newsletterRef}
                                                  >
                                                    {/* Board Wrapper */}
                                                    <div
                                                      style={{
                                                        position: "relative",
                                                        width: "100%",
                                                        maxWidth: "700px", //  desktop same, mobile shrink
                                                      }}
                                                    >
                                                      {/* Board Image */}
                                                        <img
                                                        className={`${styles.mobIMG}`}
                                                        src={weeklyActivity2}
                                                        alt="Wooden frame border with green leaves decorative nature background blank template"
                                                        style={{
                                                          width: "100%",
                                                          height: "auto",
                                                          // display: "none",
                                        
                                                        }}
                                                      />
                                                      <img
                                                      className={`${styles.desIMG}`}
                                                        src={weeklyActivity}
                                                        alt="Wooden frame border with green leaves decorative nature background blank template"
                                                        style={{
                                                          width: "100%",
                                                          height: "auto",
                                                          // display: "none",
                                        
                                                        }}
                                                      />
                                        
                                                      {/* CONTENT INSIDE BOARD */}
                                                      <div
                                                      className={`${styles.mailbox}`}
                                                        style={{
                                                          position: "absolute",
                                                          top: "55%",
                                                          left: "50%",
                                                          transform: "translate(-50%, -50%)",
                                                          width: "78%",
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        {/* Email Input */}
                                                        <input
                                                          type="email"
                                                          className={`form-control ${styles.inputbox}  mb-2 font-brandon`}
                                                          placeholder="Email ID"
                                                          style={{
                                                            borderRadius: "5px",
                                                            border: "2px solid #9ec9bb",
                                                            padding: "clamp(12px, 10vw, 6px) 18px",
                                                            fontSize: "clamp(22px, 3vw, 5px)",
                                                          }}
                                                        />
                                        
                                                        {/* Checkbox */}
                                                        <div className={`form-check ${styles.input2} d-flex justify-content-center align-items-center`}>
                                                          <input
                                                            className={`form-check-input ${styles.checkbox} me-3`}
                                                            type="checkbox"
                                                            id="weeklyCheck"
                                                            style={{
                                                              border: "1px solid #2f6f62",
                                                              transform: "scale(1.5)",
                                                            }}
                                                          />
                                                          <label
                                                            className={`form-check-label ${styles.CTA} font-brandon fs-2 lh-sm`}
                                                            htmlFor="weeklyCheck"
                                                            style={{
                                                              color: "#2f6f62",
                                                              fontSize: "clamp(14px, 3vw, 14px)",
                                                              marginBottom: "-4px",
                                                            }}
                                                          >
                                                            Send Me Weekly Activities!
                                                          </label>
                                                        </div>
                                        
                                                        {/* Small text */}
                                                        <p
                                                          className={`text-reset font-brandon ${styles.CTA} fs-5 mb-0 mb-md-2 lh-sm`}
                                                          style={{
                                                            fontSize: "clamp(10px, 1.5vw, 12px)",
                                                            marginBottom: "2px",
                                                          }}
                                                        >
                                                          We never spam. Unsubscribe anytime.
                                                        </p>
                                        
                                                        {/* Disclaimer */}
                                                        <p
                                                          className={`text-reset fs-6 ${styles.CTA} ${styles.lastmailtext} font-brandon`}
                                                          style={{
                                                            fontSize: "clamp(9px, 2.2vw, 10px)",
                                                            lineHeight: "1.3",
                                                          }}
                                                        >
                                                          By sharing your email address, you agree to receive marketing
                                                          emails and consent to our{" "}
                                                          <span className="text-decoration-underline">
                                                            Terms and Conditions
                                                          </span>{" "}
                                                          and{" "}
                                                          <span className="text-decoration-underline">
                                                            Privacy Policy
                                                          </span>
                                                          .
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                              
                                        {/* <div className="row align-items-center justify-content-center col-md-10">
                                          <div className="col-md-4 text-center">
                                            <img
                                              src={safiaElephant}
                                              alt="Cute blue cartoon elephant wearing yellow floral dress with purple garland and flower crown inside green circular frame vector illustration"
                                              width="320"
                                            />
                                          </div>
                              
                                          <div className="col-md-8 text-start">
                                            <h2 className={`mt-3 font-brandon ${styles.fs4}  fw-bold`}>
                                              Safia Bano
                                            </h2>
                                            <p className={`font-brandon ${styles.fs3} lh-sm`}>
                                              As the author, I am proud to say that I have been recognized as
                                              a New York Times best-selling author. My writing style has
                                              captivated audiences, and my stories have received widespread
                                              acclaim.
                                            </p>
                                            <hr
                                              className="my-3"
                                              style={{
                                                height: "2px",
                                                backgroundColor: "#005d52",
                                                border: "none",
                                                opacity: 1,
                                              }}
                                            />
                                            <div className="d-flex justify-content-start gap-3">
                                              <Link
                                                to={
                                                  "https://www.linkedin.com/company/jungle-morals-entertainment/?viewAsMember=true"
                                                }
                                                target="blank"
                                              >
                                                <img
                                                  src={Linkdin}
                                                  alt="LinkedIn logo icon in green circle"
                                                  srcset=""
                                                  width={"40"}
                                                  height={"40"}
                                                />
                                              </Link>
                              
                                              <Link
                                                to={"https://www.instagram.com/junglemorals/"}
                                                target="blank"
                                              >
                                                <img
                                                  src={instaIcon}
                                                  alt=""
                                                  srcset=""
                                                  width={"40"}
                                                  height={"40"}
                                                />
                                              </Link>
                                            </div>
                                          </div>
                                        </div> */}
                                      </section>
               


                <section className="container py-1 col-md-10" style={{ maxWidth: '1300px' }}
                >
                    <h3 className={`mt-3 font-brandon  ${styles.strongtextheading}`}>Similar Picks For You!</h3>
                  <div className="mt-4 mt-md-5">
                        {/* Header Section */}
                        {/* Blog Cards Grid */}
                     <div className={`row g-md-5 ${styles.blogRow} mt-5`}>
                            {blogPosts.map((post, index) => (
                                <div key={post.id} className="col-12 col-md-6 col-lg-4">
                                     <div
                         className="card h-100"
                         style={{ cursor: "pointer", border: "none" }}
                         role="button"
                         tabIndex={0}
                         onClick={() => handleBlogClick(post.slug)}
                         onKeyDown={(e) => {
                           if (e.key === "Enter" || e.key === " ") handleBlogClick(post.slug);
                         }}
                       >
                                        {/* Animal Head - Sirf image dikhegi, background nahi */}
                                        <div style={{
                                            position: 'absolute',
                                            ...animalStyles[post.animal],
                                            width: '170px',  // Size badha diya
                                            height: '170px', // Size badha diya
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            zIndex: 10,
                                        }}>
                                            {/* Sirf animal image */}
                                            <img
                                              className={`${styles.animalImg}`}
                                                src={post.animalImg}
                                                alt={post.animal}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain' // contain use karo taaki poora animal dikhe
                                                }}
                                            />
                                        </div>

                                        {/* Card Image/Content Area */}


                                        {/* Card Image/Content Area */}
                                        <div style={{
                                            height: '240px',
                                            backgroundImage: `url(${boardimg})`, // Board frame
                                            backgroundSize: 'contain',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            position: 'relative',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '10px 10px'
                                        }}>
                                            {/* Blog thumbnail image - Board ke andar fit hogi */}
                                            <img
                                                src={post.image}
                                                alt={post.alt}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain', // Image ko board ke andar fit karega
                                                    // borderRadius: '4px'
                                                }}
                                            />
                                        </div>

                                        {/* Grass decoration on top of image */}
                                        <div style={{
                                            width: "50%",
                                            minHeight: "150px",   // mobile
                                            height: "30vw",       // responsive height
                                            maxHeight: "100px",
                                            marginTop: "24%",  // desktop limit
                                            position: 'absolute',
                                            marginLeft: "61%",  // desktop limit

                                        }}>
                                            <img
                                                src={geassdivImg}
                                                alt="grass decoration"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: "contain"
                                                }}
                                                onError={(e) => {
                                                    console.log('Grass div image failed:', e);
                                                    console.log('Image path:', geassdivImg);
                                                }}
                                            />
                                        </div>

                                        <div className="card-body" style={{ padding: '1px' }}>
                                            <div className="d-flex justify-content-between align-items-center mb-2 font-brandon">
                                                <small style={{ color: ' #005d52', fontSize: '12px', fontWeight: "600" }}>{post.date}</small>
                                                <small style={{ color: ' #005d52', fontSize: '12px', fontWeight: "600" }}>{post.readTime}</small>
                                            </div>
                                            <h5 className="card-title font-brandon" style={{
                                                color: '#005d52',
                                                fontWeight: 'bold',
                                                fontSize: '22px',
                                                marginBottom: '10px'
                                            }}>
                                                {post.title}
                                            </h5>
                                            <p className="card-text font-brandon" style={{
                                                color: '#005d52',
                                                fontSize: '14px',
                                                lineHeight: '1.5',
                                                fontWeight: '400'
                                            }}>
                                                {post.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>


                    </div>
                </section>



            </div>
        </>
    );
};


export default Helpingkidslearntocontrolangerandmanagebigfeelings;



